export const app_constants = {
  "1": "Automotive",
  // '2' : 'Heavy duty',
  "2": "Truck",
  "3": "Agriculture",
  //   "4": "Ind & Con",
  "4": "Construction",
  "5": "Forklift",
  "6": "Marine",
  "7": "Lawn & Gar",
  "8": "Hi-Performance",
  "9": "EV",
};

export const marco_sale_region = {};

export const marco_app_region = {
  "1": "Europe",
  "2": "North America",
  "3": "Japan",
  "4": "Korean",
  "5": "China",
  "6": "Other",
};



// token key
export const TOKEN_KEY = 'token';
// user info key
export const USER_INFO_KEY = 'userInfo';

/**
 * 产品类型 (izUnit)
 * 0 - Part: 配件/零件（如 Brush Holder），分类层级较深，面包屑导航走 c2 路由
 * 1 - Unit: 总成/整机（如 Starter, Alternator），有 Catalogue/Components 标签页
 * 2 - Accessory: 周边/礼品，无 OE 号和 Application 属性
 */
export const IZ_UNIT = {
  PART: 0,
  UNIT: 1,
  ACCESSORY: 2,
} as const;
